import * as React from "react";

export enum ResponsivenessSetting {
  Mobile = "mobile",
  Tablet = "tablet",
  Desktop = "desktop",
}

export const useResponsiveness = () => {
  const calculateResponsivenessSetting = () => {
    if (window.matchMedia("(min-width: 1024px)").matches) {
      return ResponsivenessSetting.Desktop;
    } else if (window.matchMedia("(min-width: 768px)").matches) {
      return ResponsivenessSetting.Tablet;
    } else {
      return ResponsivenessSetting.Mobile;
    }
  };

  const [responsivenessSetting, setResponsivenessSetting] =
    React.useState<ResponsivenessSetting>(calculateResponsivenessSetting);

  React.useEffect(() => {
    const onResize = () => {
      const newResponsivenessSetting = calculateResponsivenessSetting();
      setResponsivenessSetting(newResponsivenessSetting);
    };
    window.addEventListener("resize", onResize);
    return () => {
      window.removeEventListener("resize", onResize);
    };
  }, []);

  return [responsivenessSetting];
};
